<template>
<button v-if="isEmbedded" ref="studioMenuToggle" type="button" class="studio-mobile-menu-toggle"
    aria-controls="new-sidenav" :aria-expanded="mobileMenuOpen" @click="toggleStudioMenu">
    {{ mobileMenuOpen ? '병원 메뉴 닫기' : '병원 메뉴' }}
</button>
<button v-if="isEmbedded && mobileMenuOpen" type="button" class="studio-mobile-menu-backdrop"
    aria-label="병원 메뉴 닫기" @click="closeStudioMenu" />
<aside
    id="new-sidenav"
    ref="studioSidenav"
    v-bind="$attrs"
    :tabindex="isEmbedded ? -1 : undefined"
    v-if="this.$store.state.showSidenav"
    :class="{ 'studio-mobile-open': isEmbedded && mobileMenuOpen }"
    @keydown.esc="closeStudioMenu"
>
    <div class="sidenav-header-container">
        <!-- 계정 메뉴: 이름을 누르면 「내 계정 보안」(로그아웃 바로 위)·「로그아웃」. 메뉴 권한과 관계없이 모든 직원(U2) -->
        <a-dropdown :trigger="['click']" placement="bottomLeft" :overlayStyle="{ minWidth: '180px' }">
            <button type="button" class="sidenav-userinfo-container sidenav-account-btn" aria-haspopup="menu">
                <img v-if="companyImageUrl" :src="companyImageUrl" class="user-logo" alt="main_logo" />
                <img v-else src="@/assets/img/profile_df.png" class="user-logo" alt="main_logo" />
                <div class="user-info-text">
                    <div class="hospital-name" :title="hospitalName">{{ hospitalName }}</div>
                    <div class="manager-name" :title="userName">{{ userName }}</div>
                </div>
                <DownOutlined class="sidenav-account-caret" />
            </button>
            <template #overlay>
                <a-menu @click="onAccountMenu">
                    <!-- 지원 탭: 서브 계정에는 2차 인증 수단·비밀번호가 없음(W6 C3) -->
                    <a-menu-item v-if="!supportTab" key="security">내 계정 보안</a-menu-item>
                    <a-menu-item key="logout">{{ $t('side_nav_list_logout_text') }}</a-menu-item>
                </a-menu>
            </template>
        </a-dropdown>
    </div>
    <sidenav-list />
    <div class="sidenav-footer-container">
        <div class="sidenav-item-container" @click="signOut">
            <div class="sidenav-item-icon"><img :src="signout.inactive"></div>
            <div class="sidenav-item-text">{{$t('side_nav_list_logout_text')}}</div>
        </div>
    </div>
</aside>
<!-- 창 안 여백·닫기 줄은 인증번호 창과 같은 .otp-verify-modal 규칙 -->
<a-modal v-model:open="mySecurityOpen" title="내 계정 보안" :width="560" :footer="null" centered
    destroyOnClose class="otp-verify-modal">
    <my-account-security />
    <div class="otp-footer"><a-button @click="mySecurityOpen = false">닫기</a-button></div>
</a-modal>
</template>
<script>
import { endSupportTab, getAccessToken, getProfile, isSupportTab } from "@/utils/tokenStore";
import { supportEndedUrl } from "@/utils/supportSession";
// <div class="sidenav-country-container" v-if="$store.getters.getDeptBoolean.hasDent">
//   <button 
//     class="sidenav-country-btn"
//     :class="item.isActive ? 'active' : ''"
//     v-for="item in languages"
//     @click="changeLocale(item)"
//   >
//     <img :src="getFlagImageUrl(item.code)">
//   </button>
// </div>
import { DownOutlined } from '@ant-design/icons-vue';
import SidenavList from './SidenavList.vue';
import MyAccountSecurity from '@/views/components/MyAccountSecurity.vue';
import { twoBtnDialog, } from '@/utils/utils';
import { RouterEnum, } from '@/router/router.enums';
import { isStudioEmbed, requestStudioLogout } from '@/utils/studioEmbed';

export default {
    name: 'index',
    inheritAttrs: false,
    components: {
        SidenavList,
        MyAccountSecurity,
        DownOutlined,
    },
    data() {
        return {
            isEmbedded: isStudioEmbed(),
            supportTab: isSupportTab(),
            mobileMenuOpen: false,
            mySecurityOpen: false,
            userName: '',
            hospitalName: '',
            companyImageUrl: '',
            signout: {
                active: require('@/assets/img/sidenav/signout.svg'),
                inactive: require('@/assets/img/sidenav/signout.svg'),
            },
            languages: [
                {
                    code: 'ko',
                    isActive: false,
                    redirectTo: `${RouterEnum.Dashboard.name}`
                },
                {
                    code: 'zh',
                    isActive: false,
                    redirectTo: RouterEnum.DentIssueCertificate.name
                },
                {
                    code: 'ja',
                    isActive: false,
                    redirectTo: RouterEnum.DentIssueCertificate.name
                },
            ]
        };
    },
    watch: {
        '$route.path'() { this.closeStudioMenu(); },
    },
    mounted() {
        this.loadUserInfo();
        this.$store.watch(() => this.$store.getters.getUserName, (value) => {
            console.log('value', value)
            this.userName = value;
        });
        this.$store.watch(() => this.$store.getters.getHospitalName, (value) => {
            this.hospitalName = value;
        });
        this.$store.watch(() => this.$store.getters.getCompanyImageUrl, (value) => {
            this.companyImageUrl = value;
        });
        if (getAccessToken()) this.$store.state.showSidenav = true;
        const currentLocale = this.languages.find(item => item.code === this.$i18n.locale);
        this.changeLocale(currentLocale);
    },
    created() {
        // 로컬스토리지 변경 이벤트 리스너 등록
        window.addEventListener('storage', this.handleStorageChange);
    },
    destroyed() {
        // 컴포넌트 제거 시 이벤트 리스너 제거
        window.removeEventListener('storage', this.handleStorageChange);
    },
    methods: {
        onAccountMenu({ key }) {
            if (key === 'security') this.mySecurityOpen = true;
            else this.signOut();
        },
        toggleStudioMenu() {
            if (this.mobileMenuOpen) return this.closeStudioMenu();
            this.mobileMenuOpen = true;
            this.$nextTick(() => this.$refs.studioSidenav?.focus());
        },
        closeStudioMenu() {
            if (!this.mobileMenuOpen) return;
            this.mobileMenuOpen = false;
            this.$nextTick(() => this.$refs.studioMenuToggle?.focus());
        },
        async handleStorageChange(event) {
            if (isStudioEmbed()) return;
            // 지원 탭은 다른 탭의 localStorage(일반 로그인) 변화와 무관 — 새로 고치지 않음(하던 작업 보존)
            if (isSupportTab()) return;
            switch(event.key) {
                case 'userNameHos':
                    this.userName = event.newValue;
                    window.location.reload();
                    break;
                case 'hospitalNameHos':
                    this.hospitalName = event.newValue;
                    window.location.reload();
                    break;
                case 'companyImageUrlHos':
                    this.companyImageUrl = event.newValue;
                    window.location.reload();
                    break;
                case 'accessTokenHos':
                    if(!getAccessToken()) {
                        window.location.reload();
                    }
                    break;
            }
        },
        getFlagImageUrl(name) {
            return require(`@/assets/img/flag/${name}.svg`);
        },
        async signOut() {
            const isConfirmed = await twoBtnDialog(this.$t('side_nav_list_logout_text'), this.$t('logout_dialog_content_text'), this.$t('side_nav_list_logout_text'),this.$t('logout_dialog_cancel_text'));
            if(!isConfirmed) return;
            if (isStudioEmbed()) {
                requestStudioLogout();
                return;
            }
            // 지원 탭의 로그아웃 = 지원 접속 끝(배너 [종료]와 같음) — 그 탭 지원 값만 지움
            if (this.supportTab) {
                await this.$apiInstance.post('/auth/support/end', null, { showErrorNotice: false }).catch(() => undefined);
                endSupportTab('USER');
                window.location.replace(supportEndedUrl('USER'));
                return;
            }
            await this.$store.dispatch('clearLocalStorage');
            this.$router.push({name: RouterEnum.Signin.name});
            document.querySelector('body').classList.remove('modal-open');
            window.location.reload();
        },
        loadUserInfo() {
            this.userName = getProfile('userNameHos');
            this.hospitalName = getProfile('hospitalNameHos');
            this.companyImageUrl = getProfile('companyImageUrlHos');
            // this.userName = this.$store.getters.getUserName;
            // this.hospitalName = this.$store.getters.getHospitalName;
            // this.companyImageUrl = this.$store.getters.getCompanyImageUrl;
        },
        changeLocale(language) {
            if(!this.$store.getters.getDeptBoolean.hasDent) return;
            if(language.isActive) return;

            const currentLocale = this.$i18n.locale;
            const pathWithoutLocale = this.$route.fullPath.split(`/${currentLocale}`)[0];
            const newLocale = language.code;
            const newPath = newLocale === 'ko' ? pathWithoutLocale : `${pathWithoutLocale}/${newLocale}`;


            this.$i18n.locale = newLocale;
            for (const item of this.languages) {
                item.isActive = false;
            }
            language.isActive = true;

            if (this.$route.path === RouterEnum.Dashboard.path && this.$i18n.locale !== 'ko') {
                if (language.redirectTo) {
                    this.$router.push({ name: language.redirectTo });
                }
                return;
            }

            if (this.$route.fullPath.includes(RouterEnum.Dent.path)) {
                this.$router.push(newPath);
                return;
            }

            if (language.redirectTo) {
                this.$router.push({ name: language.redirectTo });
            } else {
                this.$router.push(newPath);
            }
        }
    },
};
</script>
<style lang="scss">
  @import "@/assets/scss/sidenavbar.scss";
  .studio-mobile-menu-toggle, .studio-mobile-menu-backdrop { display: none; }
  // 계정 메뉴 단추: 원래 머리 칸 모양 그대로 + 누를 수 있다는 표시(바탕·꺾쇠)
  #new-sidenav .sidenav-header-container .sidenav-account-btn {
    width: 100%;
    gap: 10px;
    border: 0;
    border-radius: 0;
    background: transparent;
    font: inherit;
    text-align: left;
    cursor: pointer;
    &:hover, &.ant-dropdown-open { background: #f7f8f9; }
    &:focus-visible { outline: 2px solid #278aec; outline-offset: -2px; }
    .user-info-text { flex: 1; min-width: 0; width: auto; }
    .hospital-name, .manager-name { cursor: pointer; }
  }
  .sidenav-account-caret { flex: none; font-size: 12px; color: #4b5158; }
  @media screen and (max-width: 767px) {
    .studio-mobile-menu-toggle {
      display: block;
      position: fixed;
      top: 12px;
      right: 12px;
      z-index: 1052;
      padding: 8px 12px;
      border: 1px solid #e8ebed;
      border-radius: 6px;
      background: white;
      color: #17191c;
    }
    .studio-mobile-menu-backdrop {
      display: block;
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      z-index: 1050;
      border: 0;
      border-radius: 0;
      background: rgba(0, 0, 0, 0.3);
    }
    #new-sidenav.studio-mobile-open {
      display: block !important;
      z-index: 1051;
    }
  }
</style>
